import { createReadStream } from 'node:fs';
import * as readline from 'node:readline';
import { splitTextIntoDiffLines } from '@buildautomaton/types';

export function countLinesInText(text: string): number {
  return splitTextIntoDiffLines(text).length;
}

export async function countTextFileLines(filePath: string): Promise<number> {
  let bytes = 0;
  const maxBytes = 512_000;
  let lines = 0;
  const stream = createReadStream(filePath, { encoding: 'utf8' });
  const rl = readline.createInterface({ input: stream, crlfDelay: Infinity });
  for await (const _line of rl) {
    lines += 1;
    bytes += Buffer.byteLength(String(_line), 'utf8') + 1;
    if (bytes > maxBytes) {
      rl.close();
      stream.destroy();
      return lines;
    }
  }
  return lines;
}
